import React from 'react'
import PageContent from 'components/common/PageContent'
import NotifProvidersTable from 'components/organisation/notificationProviders/NotifProvidersTable'

export default function NotifProviders(props) {

    const pathElements = [
        {id: 0, title: "Home", url: "/"},
        {id: 1, title: "Organisation", url: "/organisation"},
        {id: 2, title: "Notification providers"}
    ];

    return (
        <PageContent pathElements={pathElements}>
            <NotifProvidersTable/>
        </PageContent>
    )
}